import { Button } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import * as go from 'gojs/release/go-module';
import * as React from 'react';
import { Tooltip } from 'vet-bones/components';

import { TEST_IDS } from 'src/constants/testIds';
import { useNavigationValueAndText } from 'src/containers/ProjectDiagram/hooks/entityDrawer/useNavigationValueAndText';
import { useDiagram } from 'src/containers/ProjectDiagram/hooks/useDiagramValue';
import { setDiagramSelection } from 'src/containers/ProjectDiagram/utils/setDiagramSelection';
import { uiSlice } from 'src/store/ui/ui.slice';
import { useReduxDispatch } from 'src/utils/hooks/useReduxDispatch';
import { useRouterParams } from 'src/utils/hooks/useRouterParams';

type ProjectDiagramEntityDrawerHeaderProps = { title?: string | undefined };

export const ProjectDiagramEntityDrawerHeader: React.VFC<
  ProjectDiagramEntityDrawerHeaderProps
> = ({ title }) => {
  return (
    <div className="sd-drawer-project-diagram-entity-header">
      <ProjectDiagramEntityDrawerNavigation />
      <div>{title}</div>
    </div>
  );
};

const ProjectDiagramEntityDrawerNavigation: React.VFC = () => {
  const { projectId } = useRouterParams();
  const diagram = useDiagram();
  const dispatch = useReduxDispatch();

  const { entityValue, label } = useNavigationValueAndText();

  const selectByValue = (value: string) => {
    if (!diagram) {
      return;
    }

    const nodesToSelect = diagram.nodes.filter(
      (node) => node.data.value === value
    );
    const linksToSelect = diagram.links.filter(
      (node) => node.data.value === value
    );
    const newSelection = new go.Set<go.Part>();
    newSelection.addAll(nodesToSelect);
    newSelection.addAll(linksToSelect);

    setDiagramSelection(newSelection)(diagram);
  };

  return label === null || entityValue === null ? (
    <div
      className="sd-drawer-project-diagram-entity-header__back-button"
      data-testid={TEST_IDS.projectDiagram.entityDrawer.back.placeholder}
    />
  ) : (
    <Tooltip
      content={
        <span data-testid={TEST_IDS.projectDiagram.entityDrawer.back.tooltip}>
          {label}
        </span>
      }
    >
      <div className="sd-drawer-project-diagram-entity-header__back-button">
        <Button
          data-testid={TEST_IDS.projectDiagram.entityDrawer.back.button}
          icon={IconNames.CHEVRON_LEFT}
          minimal
          onClick={() => {
            dispatch(
              uiSlice.actions.selectedPreviousEntityDrawer({
                projectId,
                entityValue,
              })
            );
            selectByValue(entityValue);
          }}
        />
      </div>
    </Tooltip>
  );
};
